import { Column, Entity, Index } from 'typeorm';
import type { EmailAddressStatus, EmailAddressStatusSource } from '../../constants/email-address-status';
import { BaseEntity } from './base.entity';

/** PD-17605 — the history of an address's status: one row per change. */
@Index('IDX_email_address_status_event_status', ['fkEmailAddressStatusId'], {})
@Entity('email_address_status_event')
export class EmailAddressStatusEventEntity extends BaseEntity {
	@Column('int', { name: 'fk_email_address_status__id', unsigned: true })
	public fkEmailAddressStatusId!: number;

	@Column('varchar', { name: 'status', length: 16 })
	public status!: EmailAddressStatus;

	@Column('varchar', { name: 'source', length: 24 })
	public source!: EmailAddressStatusSource;

	@Column('varchar', { name: 'reason', length: 500, nullable: true })
	public reason!: string | null;

	@Column('varchar', { name: 'bounceType', length: 60, nullable: true })
	public bounceType!: string | null;

	@Column('datetime', { name: 'eventDate' })
	public eventDate!: Date;
}
